import { joiResolver } from '@hookform/resolvers/joi';
import { useForm, UseFormReturn } from 'react-hook-form';
import { SchoolFormData } from '../../../models';
import schoolSchema from '../schema/schoolSchema';

interface AddSchoolReturn {
  /**
   * Perform submit action, either to call block call or unblock call, depends on the account status
   */
  submitForm: (submitData: SchoolFormData) => void;
  /**
   * Form to send edit & delete
   */
  formHook: UseFormReturn<SchoolFormData>;
  /**
   * React query mutation object
   */
}

/**
 * A hook to handle search functionality
 * @returns
 */
export const useAddSchool = (defaultFormValues?: any): AddSchoolReturn => {
  const formHook = useForm<SchoolFormData>({
    mode: 'onSubmit',
    resolver: joiResolver(schoolSchema),
    defaultValues: defaultFormValues,
  });

  const submitForm = (submitData: SchoolFormData) => {
    // do nothing
  };

  return {
    formHook,
    submitForm,
  };
};
